class Permissions {

  constructor(){
    this.nextUpdated = 0;
    this.permList = JSON.parse(localStorage.getItem("permissions"));
  }

  checkPerm(name) {
    let nowDate = new Date();
    if(this.nextUpdated < nowDate.getTime()){
      this.nextUpdated = nowDate.getTime() + 3000; // Данные из localStorage тянем не чаще, чем раз в 500мс
      this.permList = JSON.parse(localStorage.getItem("permissions"));
    }
    // Сначала проверим наличие разрешения user, т.к ему можно все
    for (let key in this.permList) {
      if (this.permList[key] === "user") {
        return true;
      }
    }
    let result = false;
    for (let key in this.permList) {
      if (this.permList[key] === name) {
        result = true;
      }
    }
    return result;
  }

  isAdduser(){
    for (let key in this.permList) {
      if (this.permList[key] === "add_user") {
        return true;
      }
    }
    return false;
  }
}

export default Permissions;
